import store from './store';

export const items = () => {
  return [
    {
      name: 'Dashboard',
      url: '/admin/dashboard',
      icon: 'icon-layers',
    },
    {
      name: 'Bedrijven',
      url: '/admin/companies',
      icon: 'icon-organization',
      permission: 'bedrijven bekijken',
    },
    {
      name: 'Locaties',
      url: '/admin/locations',
      icon: 'icon-directions',
      permission: 'locaties bekijken',
    },
    {
      name: 'Gebruikers',
      url: '/admin/users',
      icon: 'icon-people',
      permission: 'gebruikers bekijken',
    },
    {
      name: 'Orders',
      url: '/admin/orders',
      icon: 'icon-bag',
      permission: 'leveringen bekijken',
    },
    {
      name: 'Mededelingen',
      url: '/admin/announcements',
      icon: 'icon-speech',
    },
    {
      name: 'Feestdagen',
      url: '/admin/holidays',
      icon: 'icon-event',
    },
  ];
};
